import { GoldButton } from "@/components/primitives";

export default function NotFound() {
  return (
    <div
      data-testid="notfound-page"
      className="flex min-h-screen flex-col items-center justify-center bg-fs-bg px-6 text-center"
    >
      <span className="font-serif text-8xl font-light text-fs-gold/60">404</span>
      <h1 className="mt-6 fs-h2">This page could not be found.</h1>
      <p className="mt-4 max-w-md fs-body">
        The page you are looking for may have moved or no longer exists.
      </p>
      <div className="mt-10">
        <GoldButton to="/" variant="solid" testId="notfound-home">
          Back to Home
        </GoldButton>
      </div>
    </div>
  );
}
